import { Button, Flex, Heading, Highlight, Image } from "@chakra-ui/react"
import { FaAngleDown, FaArrowRightLong } from "react-icons/fa6";

import './styles/PricingComponent.css';

function PricingComponent(props: any) {

  return (
    <div>
        {/* Desktop only view */}
        <Flex className="pricing_component__parent" direction='column' gap='6'>
            <Heading color='black' fontWeight='bold' size='5xl'>
                <Highlight query={`It's that simple`} styles={{color: "#FB5383"}}>
                    We don't get paid unless you do.  It's that simple.
                </Highlight>
            </Heading>
            <Heading color='#666666' fontWeight='bold' size='xl' style={{marginTop: '30px'}}>
                Unlike our competitors, we don't charge a flat fee. We charge 5% of whatever increase we help you negotiate across your total package, with a cap of $5,000.
            </Heading>
            <Heading color='black' fontWeight='bold' size='3xl' style={{marginTop: '30px'}}>
                <Highlight query='you.' styles={{color: '#FB5383'}}>
                    Pricing that works for you.
                </Highlight>
            </Heading>
            <Flex justify='center' style={{marginTop: '40px'}}>
                <Button border='1px solid #FB5383' color='#FB5383' rounded='md' size='lg' variant='outline' onMouseDown={() => {
                    window.location.href='#commissioncalculator'
                }}>
                    Explore our Commission Calculator <FaAngleDown style={{height: "15px", width: "15px"}}/>
                </Button>
            </Flex>
        </Flex>

        {/* Mobile only view */}
        <Flex className="pricing_component__mobile_parent" direction='column' gap='6'>
            <Heading color='black' fontWeight='bold' size='4xl'>
                <Highlight query={`It's that simple`} styles={{color: "#FB5383"}}>
                    We don't get paid unless you do.  It's that simple.
                </Highlight>
            </Heading>
            <Heading color='#666666' fontWeight='bold' size='md' style={{marginTop: '20px'}}>
                Unlike our competitors, we don't charge a flat fee. We charge 5% of whatever increase we help you negotiate across your total package, with a cap of $5,000.
            </Heading>
            <Heading color='black' fontWeight='bold' size='3xl' style={{marginTop: '20px'}}>
                <Highlight query='you.' styles={{color: '#FB5383'}}>
                    Pricing that works for you.
                </Highlight>
            </Heading>
            <Flex justify='center' style={{marginTop: '20px'}}>
                <Button border='1px solid #FB5383' color='#FB5383' rounded='md' size='lg' variant='outline' onMouseDown={() => {
                    window.location.href='#commissioncalculator'
                }}>
                    Commission Calculator <FaAngleDown style={{height: "15px", width: "15px"}}/>
                </Button>
            </Flex>
        </Flex>
    </div>
  );
}

export default PricingComponent;
